import React, {useEffect, useRef} from "react";
import "./Top.scss";

export default function Top() {
  const buttonRef = useRef(null);

  function TopEvent() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }

  useEffect(() => {
    // Show the button once the user scrolls 20px down.
    function scrollFunction() {
      const button = buttonRef.current;
      // The button is gone while another route is mounted — nothing to update.
      if (!button) return;

      const isScrolled =
        document.body.scrollTop > 20 || document.documentElement.scrollTop > 20;
      button.style.visibility = isScrolled ? "visible" : "hidden";
    }

    scrollFunction(); // Make sure the button is hidden to begin with.
    // addEventListener rather than window.onscroll, so this neither clobbers
    // another handler nor outlives the component and fires against a null node.
    window.addEventListener("scroll", scrollFunction);
    return () => window.removeEventListener("scroll", scrollFunction);
  }, []);

  // When the user clicks on the button, scroll to the top of the document
  return (
    <button ref={buttonRef} onClick={TopEvent} id="topButton" title="Go to top">
      <i className="fas fa-hand-point-up" aria-hidden="true"></i>
    </button>
  );
}
